// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__J0ic8","sep":"styles_sep__lUgVS","card":"styles_card__K_Gq4","cardBody":"styles_cardBody__DxUVu","cardIconContainer":"styles_cardIconContainer__Ewfp6"};